import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, Form, Select, Switch } from 'antd-v5';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';

const notifyTimeOptions = [
  { label: '4 hours', value: 240 },
  { label: '8 hours', value: 480 },
  { label: '12 hours', value: 720 },
  { label: '18 hours', value: 1080 },
  { label: '24 hours', value: 1440 },
  { label: '48 hours', value: 2880 },
];

export const StoreNotifications = ({ form, managers, associatesList }) => {


  return (
    <SettingsContent title="NOTIFICATIONS" icon={<FontAwesomeIcon icon={['far', 'bell']} />}>
      <DescriptionBox
        className="w-100-P"
        title="Notify Managers of Unassigned Messages"
        description="When this setting is enabled, all managers will receive a notification for inbound messages from unassigned clients. Customize by disabling this setting and selecting which managers should receive notifications."
        input={
          <div className="flex-col-end">
            <Form.Item name="inbound_notify_managers" style={{ marginBottom: 8 }}>
              <Select
                mode="multiple"
                options={managers}
                disabled={Form.useWatch('inbound_notify_all', form)}
                placeholder="Select a Manager"
                style={{ width: '267px' }}
              />
            </Form.Item>
            <Form.Item name="inbound_notify_all" valuePropName="checked" style={{ marginBottom: 0 }}>
              <Checkbox>Notify all managers</Checkbox>
            </Form.Item>
          </div>
        }
      />
      <DescriptionBox
        className="w-100-P m-top-30"
        title="Notify Associates of Overdue Messages"
        description="Specific associates will be notified for any conversations that have been unread beyond the allowed time."
        input={
          <Switch
            value={!!Form.useWatch('msg_overdue_after_min', form)}
            onChange={checked => form.setFieldValue('msg_overdue_after_min', checked ? 1440 : null)}
          />
        }
      />
      {Form.useWatch('msg_overdue_after_min', form) ? (
        <div
          className="flex-col"
          style={{
            background: '#FAFAFA',
            padding: '32px',
            borderRadius: '4px',
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          <DescriptionBox
            title="Associates to Be Notified"
            description="Specific associates will be notified for any conversations that have been unread beyond the allowed time."
            input={
              <Form.Item name="overdue_notification_associates" style={{ marginBottom: 0 }}>
                <Select
                  mode="multiple"
                  options={associatesList}
                  placeholder="Select Associates"
                  style={{ width: '267px' }}
                />
              </Form.Item>
            }
          />
          <DescriptionBox
            title="How long should a message be unread before we notify you?"
            description="This setting will set how long a message will be unread before we send you an overdue email notification. Note: we check once an hour, so if a message is overdue in between windows, you will be notified at the top of the hour the next time our system checks for overdue messages."
            input={
              <Form.Item name="msg_overdue_after_min" style={{ marginBottom: 0 }}>
                <Select options={notifyTimeOptions} placeholder="Select time" style={{ width: '267px' }} />
              </Form.Item>
            }
          />
        </div>
      ) : (
        <>
          <Form.Item noStyle name="msg_overdue_after_min" />{' '}
          <Form.Item noStyle name="overdue_notification_associates" />
        </>
      )}
    </SettingsContent>
  );
};
